export enum CONTRACTS {
  // PH = "0x029583F2460AF7866920A55eBa1a090495d12631", // rinkeby
  // PH = "0x062071424e2f0CeD12aA94258E2f2922642072E7", // goerli
  // PH = "0xAf555c317608d4F9AebAe2C97bB2984656F408DF", // goerli andi
  // PH = "0x63570C8e496A0EfA53edeEe604522052F1dCE594", // goerli daniel
  PH = "0xAf555c317608d4F9AebAe2C97bB2984656F408DF", // mainnet daniel
}
